"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiChip = void 0;
var colors_1 = require("../colors");
exports.MuiChip = {
    defaultProps: {
        variant: 'outlined',
        color: 'primary',
    },
    styleOverrides: {
        root: {
            marginRight: '8px',
            '&.Mui-focusVisible': {
                transition: 'background-color 300ms',
                outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
                outlineOffset: '3px',
            },
        },
        colorPrimary: {
            transition: 'all 300ms',
            color: colors_1.tannerBlack,
            borderColor: colors_1.tannerGray['300'],
            '&.MuiChip-clickable': {
                '&.MuiChip-outlined': {
                    '&:hover': {
                        transition: 'background-color 300ms, border-color 300ms, box-shadow 300ms',
                        boxShadow: "0 0 0 2px ".concat(colors_1.tannerGray['200']),
                        borderColor: colors_1.tannerGray['600'],
                    },
                },
            },
            '& .MuiChip-deleteIcon': {
                color: colors_1.tannerGray['600'],
                '&:hover, &:active': {
                    color: colors_1.tannerGray['700'],
                    backgroundColor: colors_1.tannerGray['200'],
                },
            },
        },
        colorError: {
            '& .MuiChip-deleteIcon': {
                color: colors_1.tannerSemantic.error.color,
                '&:hover,&:active': {
                    color: colors_1.tannerSemantic.error.color,
                    backgroundColor: colors_1.tannerSemantic.error['100'],
                },
            },
            '&.MuiChip-clickable': {
                '&.MuiChip-outlined': {
                    '&:hover': {
                        boxShadow: "0 0 0 2px #FBC4C7",
                    },
                },
            },
            '&.MuiChip-filledError': {
                '& .MuiChip-deleteIcon': {
                    '&:hover,&:active': {
                        color: colors_1.tannerWhite,
                        backgroundColor: colors_1.tannerSemantic.error['300'],
                    },
                },
                '&.Mui-focusVisible': {
                    outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
                    outlineOffset: '3px',
                    backgroundColor: '#D70E16',
                },
                '&.MuiChip-clickable:hover': {
                    backgroundColor: '#B00007',
                },
            },
        },
        colorInfo: {
            color: colors_1.tannerSemantic.info.color,
            borderColor: colors_1.tannerSemantic.info.color,
            '& .MuiChip-deleteIcon': {
                color: colors_1.tannerSemantic.info.color,
                '&:hover,&:active': {
                    color: colors_1.tannerSemantic.info.color,
                    backgroundColor: colors_1.tannerSemantic.info['100'],
                },
            },
            '&.MuiChip-clickable': {
                '&.MuiChip-outlined': {
                    '&:hover': {
                        boxShadow: "0 0 0 2px #BCD5F8",
                    },
                },
            },
            '&.MuiChip-filledInfo': {
                color: colors_1.tannerWhite,
                backgroundColor: colors_1.tannerSemantic.info.color,
                '&:focus-visible, &.Mui-focusVisible': {
                    backgroundColor: colors_1.tannerSemantic.info.color,
                    outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
                    outlineOffset: '3px',
                },
                '&.MuiChip-clickable': {
                    '&:hover': {
                        backgroundColor: '#0049AB',
                    },
                },
                '& .MuiChip-deleteIcon': {
                    '&:hover,&:active': {
                        color: colors_1.tannerWhite,
                        backgroundColor: colors_1.tannerSemantic.info['300'],
                    },
                },
            },
        },
        colorSuccess: {
            '& .MuiChip-deleteIcon': {
                color: colors_1.tannerSemantic.success.color,
                '&:hover,&:active': {
                    color: colors_1.tannerSemantic.success.color,
                    backgroundColor: colors_1.tannerSemantic.success['100'],
                },
            },
            '&.MuiChip-clickable': {
                '&.MuiChip-outlined': {
                    '&:hover': {
                        boxShadow: "0 0 0 2px #A2DDBE",
                    },
                },
            },
            '&.MuiChip-filledSuccess': {
                '& .MuiChip-deleteIcon': {
                    '&:hover,&:active': {
                        color: colors_1.tannerWhite,
                        backgroundColor: colors_1.tannerSemantic.success['300'],
                    },
                },
                '&.Mui-focusVisible': {
                    backgroundColor: '#2E7D32',
                    outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
                    outlineOffset: '3px',
                },
                '&.MuiChip-clickable:hover': {
                    backgroundColor: '#00511B',
                },
            },
        },
        filled: {
            '& .MuiChip-deleteIcon': {
                color: colors_1.tannerWhite,
            },
            '&:hover': {
                boxShadow: "0 0 0 0",
            },
            '&.MuiChip-deletable': {
                '& .MuiChip-label': {
                    paddingRight: 11,
                    paddingLeft: 12,
                },
            },
        },
        filledPrimary: {
            transition: 'all 300ms',
            color: colors_1.tannerWhite,
            backgroundColor: colors_1.tannerSemantic.info.color,
            '&.MuiChip-clickable': {
                '&.Mui-focusVisible': {
                    transition: 'background-color 300ms',
                    backgroundColor: colors_1.tannerSemantic.info.color,
                    outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
                    outlineOffset: '3px',
                },
                '&:hover': {
                    backgroundColor: '#0049AB',
                    transition: 'background-color 300ms',
                },
            },
            '& .MuiChip-deleteIcon': {
                color: colors_1.tannerWhite,
                '&:hover, &:active': {
                    color: colors_1.tannerWhite,
                    backgroundColor: colors_1.tannerSemantic.info['300'],
                },
            },
        },
        sizeMedium: {
            fontSize: '14px',
        },
        sizeSmall: {
            fontSize: '12px',
        },
    },
};
//# sourceMappingURL=MuiChip.js.map